export const roads = {
	en: {
		subtitle: ["Create new route", "Information of point of interest"],
		tabs: ["ROUTES", "P.O.I.", "ROUTE DESIGN", "DETAILS"],
		actions: {
			search: "Search",
			trace: "Trace route",
			next: "Next",
			save: "Save",
			create: "CREATE ROUTE",
			cancel: "Cancel",
			del: "Delete",
			confirm: "Do you want to delete _ELEM_ from the list?",
		},
		tooltips: {
			route: {
				activate: "Activate / Desactivate route",
				color: "Select route color",
				download: "Download route",
				edit: "Edit route",
				delete: "Delete route",
				hours: "hrs",
				minutes: "min",
				seconds: "sec",
				minimum: "min",
				maximum: "max",
			},
			poi: {
				edit: "Edit POI",
				delete: "Delete POI",
			},
		},
		forms: {
			route: {
				pois: {
					label: "",
					placeholder: "",
					required:
						"You must select at least 2 points of interest to create the route",
					error: "The route can not be displayed",
				},
				name: {
					label: "Name of the route",
					placeholder: "Name of the route",
					required: "Name is required",
					error: "Name must have at least 4 characters",
				},
				devices: {
					label: "Associated device",
					placeholder: "Select a device",
					required: "You must select at least 1 device",
					error: "",
				},
				radius: {
					label: "Point radius (yards)",
					placeholder: "",
					required: "Radius is required",
					error: "",
				},
				color: {
					label: "Color of the route",
					placeholder: "",
					required: "Color is required",
					error: "",
				},
				mintime: {
					label: "Minimum time",
					placeholder: "Minimum time in point of interest (minutes)",
					required: "Minimum time is required",
					error: "",
				},
				maxtime: {
					label: "Maximum time",
					placeholder: "Maximum time in point of interest (minutes)",
					required: "Maximum time is required",
					error: "",
				},
				days: {
					label: "Days of activity",
					placeholder: "All",
					required: "You must select at leats 1 day",
					error: "",
				},
				schedule: {
					label: "Activation schedule",
					placeholder: "",
					required: "Schedule is required",
					error: "",
				},
				emails: {
					label: "Notify to",
					placeholder: "Email or cell phone number",
					tooltip: "example@domain.com or 5551234567",
					required: "",
					error: "Invalid email or invalid number (10 digits)",
				},
			},
			poi: {
				name: {
					label: "Name of the point of interest",
					placeholder: "Name of the point of interest",
					required: "",
					error: "",
				},
				description: {
					label: "Description",
					placeholder: "Description",
					required: "",
					error: "",
				},
			},
		},
		notifications: {
			route: {
				empty: "Empty list",
				create: "Route _NAME_ has been created correctly.",
				edit: "Route _NAME_ has been updated.",
				delete: "Route has been removed.",
				trace: "The new route has not been drawn after moving the positions",
				errors: {
					invalid: "The directions are invalid.",
					exceeded:
						"Too many directions were provided. Maximun 10 directions.",
					notfound:
						"At least one of directions could not be geocoded.",
					overlimit: "The webpage has gone over the requests limit",
					denied: "The webpage is not allowed to use the directions service.",
					unknown:
						"A directions request could not be processed due to a server error. You try again.",
					zero: "No route could be found between the origin and destination.",
					noDevice: "You must select at least 1 device",
				},
			},
			poi: {
				empty: "No selected points of interest",
				create: "POI _NAME_ has been created correctly.",
				edit: "POI _NAME_ has been updated.",
				delete: "POI has been removed.",
			},
		},
	},
	es: {
		subtitle: ["Creación de ruta", "Información del punto de interés"],
		tabs: ["RUTAS", "P.O.I.", "DISEÑO DE RUTA", "DETALLES"],
		actions: {
			search: "Búsqueda",
			trace: "Trazar ruta",
			next: "Siguiente",
			save: "Guardar",
			create: "CREAR RUTA",
			cancel: "Cancelar",
			del: "Eliminar",
			confirm: "¿Desea eliminar _ELEM_ de la lista?",
		},
		tooltips: {
			route: {
				active: "Activar/Desactivar ruta",
				color: "Seleccionar color de ruta",
				download: "Descargar ruta",
				edit: "Editar ruta",
				delete: "Eliminar ruta",
				hours: "hrs",
				minutes: "min",
				seconds: "seg",
				minimum: "mín",
				maximum: "máx",
			},
			poi: {
				edit: "Editar POI",
				delete: "Eliminar POI",
			},
		},
		forms: {
			route: {
				pois: {
					label: "",
					placeholder: "",
					required:
						"Debe seleccionar por lo menos 2 puntos de interes para crear la ruta",
					error: "La ruta no se puede mostrar",
				},
				name: {
					label: "Nombre de la ruta",
					placeholder: "Nombre de la ruta",
					required: "Nombre es requerido",
					error: "Nombre debe tener mínimo 4 letras",
				},
				devices: {
					label: "Dispositivo asociado",
					placeholder: "Selecciona un dispositivo",
					required: "Debe seleccionar al menos 1 dispositivo",
					error: "",
				},
				radius: {
					label: "Radio de los puntos (mts)",
					placeholder: "",
					required: "Radio es requerido",
					error: "",
				},
				color: {
					label: "Color de la ruta",
					placeholder: "",
					required: "Color es requerido",
					error: "",
				},
				mintime: {
					label: "Tiempo mínimo",
					placeholder: "Tiempo mínimo en punto de interés (minutos)",
					required: "Tiempo mínimo es requerido",
					error: "",
				},
				maxtime: {
					label: "Tiempo máximo",
					placeholder: "Tiempo máximo en punto de interés (minutos)",
					required: "Tiempo máximo es requerido",
					error: "",
				},
				days: {
					label: "Dias de actividad",
					placeholder: "Todos",
					required: "Debe seleccionar al menos 1 día",
					error: "",
				},
				schedule: {
					label: "Horario de activación",
					placeholder: "",
					required: "Horario es requerido",
					error: "",
				},
				emails: {
					label: "Notificar a",
					placeholder: "Correo electrónico o número celular",
					tooltip: "ejemplo@dominio.com o 9999887766",
					required: "",
					error: "Correo electrónico invalido ó Número invalido (10 digitos)",
				},
			},
			poi: {
				name: {
					label: "Nombre del punto de interés",
					placeholder: "Nombre del punto de interés",
					required: "",
					error: "",
				},
				description: {
					label: "Descripción",
					placeholder: "Descripción",
					required: "",
					error: "",
				},
			},
		},
		notifications: {
			route: {
				empty: "Lista vacía",
				create: "La ruta _NAME_ ha sido creada correctamente.",
				edit: "La ruta _NAME_ ha sido actualizada.",
				delete: "La ruta _NAME_ se ha eliminado",
				trace: "No se ha trazado la nueva ruta después de mover las posiciones",
				errors: {
					invalid: "Las indicaciones no son válidas.",
					exceeded:
						"Se proporcionaron demasiadas direcciones. Máximo 10 direcciones.",
					notfound:
						"Al menos una de las direcciones no se pudo geocodificar.",
					overlimit:
						"La página web ha superado el límite de solicitudes.",
					denied: "La página web no puede usar el servicio de indicaciones.",
					unknown:
						"No se pudo procesar una solicitud de indicaciones debido a un error del servidor. Intenta de nuevo.",
					zero: "No se pudo encontrar ninguna ruta entre el origen y el destino.",
					noDevice: "Debe seleccionar por lo menos 1 dispositivo",
				},
			},
			poi: {
				empty: "Sin puntos de interés seleccionados",
				create: "El POI _NAME_ ha sido creada correctamente.",
				edit: "El POI _NAME_ ha sido actualizada.",
				delete: "El POI _NAME_ se ha eliminado",
			},
		},
	},
};
